function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".step_1_svg__b{fill:#eae9ef}.step_1_svg__c{fill:#614cb4}.step_1_svg__d{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(.5 .5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.035 84.513h88.78a1.033 1.033 0 001.032-1.032V1.032A1.033 1.033 0 0089.815 0H1.035A1.033 1.033 0 00.003 1.032v82.449a1.033 1.033 0 001.032 1.032zM89.818.413a.62.62 0 01.619.619v82.45a.62.62 0 01-.619.619H1.035a.62.62 0 01-.619-.619V1.032a.62.62 0 01.619-.619z",
  fill: "#a59bc3",
  stroke: "#a59bc3",
  opacity: 0.412
}), /*#__PURE__*/React.createElement("path", {
  className: "step_1_svg__b",
  d: "M47.864 21.424a.7.7 0 110 1.4H9.422a.7.7 0 110-1.4zM47.864 25.628a.7.7 0 110 1.4H28.239a.7.7 0 110-1.4zM81.464 45.975a.7.7 0 110 1.4H9.386a.7.7 0 110-1.4zM81.464 50.179a.7.7 0 110 1.4H28.202a.7.7 0 110-1.4zM81.464 54.287a.7.7 0 010 1.4H9.386a.7.7 0 010-1.4zM81.464 58.491a.7.7 0 110 1.4H28.202a.7.7 0 110-1.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_1_svg__c",
  d: "M57.58 36.185h55.727a1.033 1.033 0 001.032-1.032V10.698a1.033 1.033 0 00-1.032-1.032H57.58a1.033 1.033 0 00-1.032 1.032v24.455a1.033 1.033 0 001.032 1.032zM9.831 74.847H30.95a1.033 1.033 0 001.032-1.032v-3.384a1.033 1.033 0 00-1.032-1.032H9.831a1.033 1.033 0 00-1.032 1.032v3.384a1.033 1.033 0 001.032 1.032z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_1_svg__d",
  d: "M87.944 18.243c.242 0 .438.315.437.7s-.2.7-.437.7h-20.66c-.242 0-.438-.315-.437-.7s.2-.7.437-.7zM87.944 22.302c.242 0 .438.315.437.7s-.2.7-.437.7h-20.66c-.242 0-.438-.315-.437-.7s.2-.7.437-.7zM87.943 26.313c.242 0 .438.315.437.7s-.2.7-.437.7h-8.89c-.242 0-.438-.315-.437-.7s.2-.7.437-.7z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "step_1_svg__d",
  cx: 5.606,
  cy: 5.606,
  transform: "translate(92.827 17.319)",
  r: 5.606
}));

function SvgStep1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.838 85.513",
    className: "w-full h-full"
  }, props), _ref, _ref2);
}

export default SvgStep1;